module.exports = __webpack_public_path__ + "static/media/moreModal.95c75d5e.jpg";